import apiClient from '../service/api'

/**
 * 어드민 셀프커스텀 슬롯(보이스/아바타) 조회·삭제 (이슈 #328).
 *
 * - 조회: workspaceId 미지정 시 전역, 지정 시 해당 워크스페이스 한정. soft-deleted 항목 포함(deletedAt not-null).
 * - 삭제: 1단계 soft-release(리소스 deleted_at 마킹 + 워크스페이스 할당 제거, 본데이터·원본 보존).
 *   복구는 별도 API 없이 DB 수동 런북으로 처리한다.
 */

// GET /api/v1/admin/custom-voices 응답 항목 (AdminVoiceSlotResponse)
export interface AdminVoiceSlot {
  voiceConversionId: number
  name: string | null
  sampleUrl: string | null // 대표 Voice 샘플. 생성 중이면 null
  status: string | null
  workspaceId: number | null
  workspaceName: string | null
  userEmail: string | null
  createdAt: string | null
  deletedAt: string | null // not-null 이면 soft-deleted
}

// GET /api/v1/admin/custom-avatars 응답 항목 (AdminAvatarSlotResponse)
export interface AdminAvatarSlot {
  selfCustomAvatarHistoryId: number
  aivatarId: number | null // null = 미완성(PROCESSING/FAIL) — 아직 Aivatar 없음
  name: string | null
  thumbnailUrl: string | null // 미완성이면 null
  status: string | null
  workspaceId: number | null
  workspaceName: string | null
  userEmail: string | null
  createdAt: string | null
  deletedAt: string | null // not-null 이면 soft-deleted
}

export const getCustomVoices = async (workspaceId?: number): Promise<AdminVoiceSlot[]> => {
  const { data } = await apiClient.get('/v1/admin/custom-voices', {
    params: workspaceId != null ? { workspaceId } : undefined,
  })
  return data
}

export const getCustomAvatars = async (workspaceId?: number): Promise<AdminAvatarSlot[]> => {
  const { data } = await apiClient.get('/v1/admin/custom-avatars', {
    params: workspaceId != null ? { workspaceId } : undefined,
  })
  return data
}

export const deleteCustomVoice = async (voiceConversionId: number): Promise<void> => {
  await apiClient.delete(`/v1/admin/custom-voices/${voiceConversionId}`)
}

export const deleteCustomAvatar = async (selfCustomAvatarHistoryId: number): Promise<void> => {
  await apiClient.delete(`/v1/admin/custom-avatars/${selfCustomAvatarHistoryId}`)
}
